import Vue from 'vue';
import productTransformer from './../../transformers/product';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default product => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('products/merge', productTransformer.sendMerge(product))
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/product/merge.js